import pegasus from "../../assets/scripts/global/01-pegasus";

document.addEventListener("alpine:init", () => {
    Alpine.data("navigation", () => ({
        isMobile: true,
        menuOpen: false,
        mobMenuOpen: false,
        mobMegaMenu: null,
        mobSubMenu: null,
        megaMenuOpen: null,
        subMenu: null,
        ctaColor: null,
        isFixed: false,
        nav: null,
        navHeight: 0,
        positionTop: 0,
        init() {
            this.nav = this.$refs.navBar;
            this.positionTop = pegasus.getElemOffset(this.$el);

            pegasus.onResizeFinished(() => {
                this.isMobile = window.outerWidth <= 1280;

                setTimeout(() => {
                    this.checkNavHeight();
                }, 200);
            }, true);

            window.addEventListener(
                "pegasus-territory-switcher-close",
                (event) => {
                    setTimeout(() => {
                        this.checkNavHeight();
                    }, 200);
                }
            );

            window.addEventListener("pegasus-rad-open", (event) => {
                this.openDemo();
            });

            window.addEventListener("pegasus-rad-close", (event) => {
                this.closeDemo();
            });

            window.addEventListener("pegasus-lang-open", (event) => {
                this.openLang();
            });

            window.addEventListener("pegasus-lang-close", (event) => {
                this.closeLang();
            });
        },
        checkNavHeight() {
            this.navHeight = this.nav.clientHeight;

            setTimeout(() => {
                this.navHeight = this.nav.clientHeight;
            }, 300);

            this.$refs.spacer.style.height = this.nav.clientHeight + "px";
        },
        fix() {
            if (this.isFixed) {
                if (window.scrollY <= this.positionTop.top) {
                    this.isFixed = false;
                }
            } else {
                if (window.scrollY >= this.positionTop.top) {
                    this.isFixed = true;
                }
            }
        },
        openLang() {
            this.closeAll();
            this.navZedTop();
        },
        closeLang() {
            this.closeAll();
        },
        openDemo() {
            this.closeAll();
            this.navZedTop();
            this.lockScroll();
            document.getElementById("page-header").classList.add("rad-open");
        },
        closeDemo() {
            document.getElementById("page-header").classList.remove("rad-open");
            this.closeAll();
        },
        openMobNav() {
            this.closeAll();
            this.navZedTop();
            this.mobMenuOpen = true;
            this.lockScroll();
            window.dispatchEvent(new CustomEvent("pegasus-mobnav-open"));
        },
        openMegaNav(nav) {
            if (this.megaMenuOpen === nav) {
                this.closeAll();
            } else {
                this.closeAll();
                this.navZedTop();
                this.megaMenuOpen = nav;
                this.subMenu = this.megaMenuOpen + "-1";
                this.lockScroll();
            }
        },
        closeAll() {
            document
                .getElementById("page-header")
                .style.removeProperty("z-index");
            this.megaMenuOpen = null;
            this.mobMenuOpen = false;
            this.mobSubMenu = null;
            this.ctaColor = null;
            this.unlockScroll();
            window.dispatchEvent(new CustomEvent("pegasus-mobnav-close"));
        },
        navZedTop() {
            document.getElementById("page-header").style.zIndex = "9999";
        },
        lockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
        },
        unlockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        },
    }));
});
